import { ERROR_DISMISS } from '../constants/ActionTypes';

// eslint-disable-next-line import/prefer-default-export
export function dismiss() {
  return { type: ERROR_DISMISS };
}
